import { Link } from "gatsby"
import { navigate } from "gatsby"
import React from "react"

import { FaBookOpen } from "../../AppReactIcons"
import { DarkAppButton } from "../buttons"
import { iListingCardView } from "../types"
import { CardContentWrapper, CardImage, CardWrapper } from "./base"

export const ListingCardView: React.FC<iListingCardView> = ({
  title,
  image,
  // description,
  link,
}) => {
  const CardLink = () => {
    if (!link) return <React.Fragment />
    else
      return (
        <div className="flex item-center mt-4">
          <Link to={link}>
            <DarkAppButton title="Read more" Icon={<FaBookOpen />} />
          </Link>
        </div>
      )
  }

  return (
    <CardWrapper>
      <div
        className="cursor-pointer"
        onClick={() => {
          if (!link) return
          navigate(link)
        }}
      >
        <CardImage src={image} />
      </div>
      <CardContentWrapper>
        <h1 className="text-site-blue-dark text-lg">{title}</h1>
        {/* {description ? (
          <p className="text-sm my-2">{description}</p>
        ) : (
          <React.Fragment />
        )} */}
        <div className="flex flex-1 items-end">
          <CardLink />
        </div>
      </CardContentWrapper>
    </CardWrapper>
  )
}

export const ListingCard: React.FC<iListingCardView> = ({ ...rest }) => {
  return <ListingCardView {...rest} />
}
